import api from "../index"
import { apiTags } from "../tags"

const wealthPartnersApi = api.injectEndpoints({
  endpoints: (build) => ({
    getWealthPartnersList: build.query({
      query: (params) => ({
        url: `/wealth-partners`,
        method: "GET",
        params,
      }),
    }),
    getWealthPartner: build.query({
      query: ({ id }) => ({
        url: `/wealth-partners/${id}`,
        method: "GET",
      }),
    }),
    getWealthPartnerByToken: build.query({
      query: ({ token }) => ({
        url: `/public/wealth-partners/bytoken/${token}`,
        method: "GET",
      }),
    }),
    wealthPartnersVerifyOtp: build.mutation({
      query: (params) => ({
        url: `/public/wealth-partners/verifyOtp`,
        method: "POST",
        body: params,
      }),
    }),
    inviteWealthPartners: build.mutation({
      query: (body) => ({
        url: `/wealth-partners`,
        method: "POST",
        body,
      }),
    }),
    updateWealthPartner: build.mutation({
      query: ({ id, ...params }) => ({
        url: `/wealth-partners/${id}`,
        method: "POST",
        body: params,
      }),
    }),
    reInviteWealthPartner: build.mutation({
      query: ({ id }) => ({
        url: `/wealth-partners/${id}/re-invite`,
        method: "GET",
      }),
    }),
    deleteWealthPartners: build.mutation({
      query: ({ id }) => ({
        url: `/wealth-partners/${id}`,
        method: "DELETE",
      }),
    }),
    approveKYCSubmissionPartner: build.mutation({
      query: ({ id, ...body }) => ({
        url: `/wealth-partners/${id}/approve/kyc`,
        method: "POST",
        body,
      }),
    }),
    rejectKYCSubmissionPartner: build.mutation({
      query: ({ id }) => ({
        url: `/wealth-partners/${id}/reject/kyc`,
        method: "GET",
      }),
    }),
    raiseQueryKYCPartner: build.mutation({
      query: ({ id, ...body }) => ({
        url: `/kyc/${id}/raise/query`,
        method: "POST",
        body,
      }),
    }),
    getWpsigningRequests: build.query({
      query: (params) => ({
        url: `/wealth-partners/signingRequests`,
        method: "GET",
        params,
      }),
    }),
  }),
})

export const {
  useLazyGetWealthPartnersListQuery,
  useLazyGetWealthPartnerQuery,
  useLazyGetWealthPartnerByTokenQuery,
  useInviteWealthPartnersMutation,
  useUpdateWealthPartnerMutation,
  useDeleteWealthPartnersMutation,
  useWealthPartnersVerifyOtpMutation,
  useReInviteWealthPartnerMutation,
  useApproveKYCSubmissionPartnerMutation,
  useRejectKYCSubmissionPartnerMutation,
  useRaiseQueryKYCPartnerMutation,
  useLazyGetWpsigningRequestsQuery,
} = wealthPartnersApi
